import FullWidthCta from './fullWidthCta'
export default FullWidthCta